export default "__VITE_ASSET__BZGZ1X$m__"